import { isSameDay } from 'date-fns';
import { convertZonedDateToSystemDate } from './DateUtils2.js';

const getTzIsSameDay = (tzDateLeft, tzDateRight) => {
    const systemLeftDate = convertZonedDateToSystemDate(tzDateLeft);
    const systemRightDate = convertZonedDateToSystemDate(tzDateRight);
    return isSameDay(systemLeftDate, systemRightDate);
};

export { getTzIsSameDay };
